"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Currency = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "25", viewBox: "0 0 24 25", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        fillRule: "evenodd",
        d: "M16.5 23.29a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm-3.2-7.544v.847h.55c-.01.11-.01.21-.01.32 0 .131 0 .252.01.373h-.55v.847h.682c.363 1.397 1.331 2.266 2.552 2.266 1.166 0 1.97-.66 2.233-1.87h-1.045c-.154.54-.572.87-1.188.87-.704 0-1.199-.496-1.43-1.266h1.628l.176-.847H14.95c-.01-.12-.01-.242-.01-.374 0-.11 0-.209.01-.319h2.046l.165-.847h-2.079c.231-.803.737-1.32 1.452-1.32.616 0 1.034.33 1.188.87h1.045c-.264-1.21-1.067-1.87-2.233-1.87-1.232 0-2.222.901-2.563 2.32h-.67Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        fillRule: "evenodd",
        d: "M9.553 13.958a6.5 6.5 0 1 1 4.117-4.117 7.525 7.525 0 0 0-4.117 4.117Zm1.509-.731a6.534 6.534 0 0 0 1.876-1.876 6.536 6.536 0 0 0-1.876 1.876Zm-5.86-4.853v-.847h1.232L4.707 4.535h1.21l1.606 2.893 1.595-2.893h1.177L8.557 7.527H9.79v.847H8.062v.693H9.79v.847H8.062v1.375H6.93V9.914H5.202v-.847H6.93v-.693H5.202Z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Currency;
